import { render } from "./CreateAppoinmentsPassForm.vue?vue&type=template&id=5d0355d8"
import script from "./CreateAppoinmentsPassForm.vue?vue&type=script&lang=js"
export * from "./CreateAppoinmentsPassForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__